import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { InterpreterViewStore } from "../../store/InterpreterViewStore";
import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { FormControl } from "@mui/material";
import { ShowDateTime } from "../../../common/controls";

export type InterpreterViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  nameValue?: { displayId: string; id: string } | null;
  name: string;
  createdAt_Value?: { displayId: string; id: string } | null;
  createdAt_: Date | null;
  lastUpdatedAt_Value?: { displayId: string; id: string } | null;
  lastUpdatedAt_: Date | null;
  interpreterViewStore: InterpreterViewStore;
};

export const InterpreterViewForm: React.FC<InterpreterViewFormProps> = observer(
  ({
    onPrint = () => {},
    onCancel = () => {},
    onEdit,
    showToolbox = true,
    name = "",
    createdAt_ = null,
    lastUpdatedAt_ = null,
    interpreterViewStore,
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            editForm={onEdit}
            printForm={() => onPrint(handlePrint)}
            closeForm={() => onCancel()}
          />
        )}
        <Box ref={componentRef}>
          <GroupContainer
            id="null"
            title={langStore.groupInterpreterLabel}
            collapsible={true}
          >
            <FormControl fullWidth>
              <ShowMultiLine
                value={name}
                label={langStore.InterpreterNameLabel}
              />
            </FormControl>
          </GroupContainer>

          <GroupContainer
            id="systemDates"
            title={langStore.groupInterpreterSystemDatesLabel}
            collapsible={true}
            expanded={interpreterViewStore.getCardState("systemDates")}
            toggleExpand={() =>
              interpreterViewStore.toggleCardState("systemDates")
            }
          >
            <FormControl fullWidth>
              <ShowDateTime
                value={createdAt_}
                label={langStore.InterpreterCreatedAt_Label}
              />
              <ShowDateTime
                value={lastUpdatedAt_}
                label={langStore.InterpreterLastUpdatedAt_Label}
              />
            </FormControl>
          </GroupContainer>
        </Box>
      </Grid>
    );
  }
);
